import { ResourceOptions } from 'react-admin';
import { FaTh } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxLevelProbabilities;
export const icon = FaTh;
export const options: ResourceOptions = {
  label: 'module.blindBox.levelProbabilities',
};
